module.exports = __webpack_public_path__ + "static/img/file.2ba6875.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Export/file.png
// module id = 337
// module chunks = 0